import {ConfirmationPinForm} from '../../../fields/confirmationPin/types'

export const buildConfirmationPinForm = (): ConfirmationPinForm => {
  return {
    confirmationPin: undefined
  }
}
